import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppChallengeUserPopupAchievedPage } from './app-challenge-user-popup-achieved';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppChallengeUserPopupAchievedPage,
  ],
  imports: [
    IonicPageModule.forChild(AppChallengeUserPopupAchievedPage),
    PipesModule,
    DirectivesModule,
  ],
})
export class AppChallengeUserPopupAchievedPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-challenge-user-popup-achieved/app-challenge-user-popup-achieved.module.ts